<button
    mat-icon-button
    (click)="openNotificationsDialog()"
    matTooltip="View notifications"
    matTooltipPosition="below"
    class="notifications-toggle-btn"
    [class.has-unread]="hasUnreadNotifications"
    aria-label="View notifications"
>
    <mat-icon>notifications</mat-icon>
</button>
